import http from "../../core/services/http.service";
import {AppSettings} from "@/shared/AppSettings";
import ExportsService from "@/core/services/exports.service";

export default {
  getReceipts(params = null, expand = null) {
    return http.get(`/api/v1/receipts/${expand ? '?expand=' + expand : ''}`, {params});
  },
  getReceipt(id, expand, params = {}) {
    return http.get(`/api/v1/receipts/${id}/?expand=${expand}`, {params});
  },
  updateReceipt(id, data, expand = '') {
    return http.put(`/api/v1/receipts/${id}/?expand=${expand}`, data);
  },
  partialUpdateReceipt(id, data, expand = '') {
    return http.patch(`/api/v1/receipts/${id}/?expand=${expand}`, data);
  },
  createReceipt(data, expand = 'customer.billing_address,miscellaneous_items,item_locations') {
    return http.post(`/api/v1/receipts/?expand=${expand}`, data);
  },
  getReceiptPdfData(uuid, data = {}) {
    return http.post(AppSettings.getUrl(`/api/v1/receipts/${uuid}/pdf-data/`), data);
  },
  getReceiptSticker(uuid) {
    return http.get(AppSettings.getUrl(`/api/v1/receipts/${uuid}/sticker/`));
  },
  async getReceiptItemsImagesZipData(uuid) {
    let response = await ExportsService.generateToken();
    if (!response.success) {
      return false;
    }

    window.open(AppSettings.url() + `/api/v1/receipts/${uuid}/batch-download-inventory-images/?token=${response.body.token}`, '_blank')
  },
  createOrUpdateReceipt(data) {
    if (data.uuid) {
      return this.updateReceipt(data.uuid, data);
    }
    return this.createReceipt(data);
  },
  removeReceipt(uuid) {
    return http.delete(`/api/v1/receipts/${uuid}/`)
  },
  batchRemoveReceipts(uuids) {
    return http.delete(`/api/v1/receipts/`, {
      data: {uuids}
    });
  },
  getGeneralFields() {
    return {
      translatableFields: [],
    }
  },
  async getDashboardGeneralInfo(params) {
    return http.get(`/api/v1/receipts/dashboard/general-info/`, {params});
  },
  async getDashboardItemsByCategory(params) {
    let response = await http.get(`/api/v1/receipts/dashboard/items-by-category/`, {params});

    const returnData = [];

    if (response.success) {
      response.body.forEach(item => returnData.push({name: item.key, value: item.value}));
    }

    return returnData;
  },
  // async getInventoryQrCodesUrl(receiptUuid) {
  //   let response = await ExportsService.generateToken();
  //   if (!response.success) {
  //     return false;
  //   }
  //   return AppSettings.url() + `/api/v1/receipts/${receiptUuid}/items-qr-code-pdf-data/?token=${response.body.token}`
  // },
};
